import { observer } from 'mobx-react-lite';
import { Button, Card, Container, Header, Icon, Label, Segment } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import format from 'date-fns/format';
import PermitFormStep6FinalReviewRightSchedule1 from './PermitFormStep6FinalReviewRightSchedule1';
import PermitFormStep6FinalReviewRightSchedule2 from './PermitFormStep6FinalReviewRightSchedule2';
import { useStore } from '../../../../app/stores/store';
import VehicleCardContent from '../../common/VehicleCardContent';
import RiderCardContent from '../../common/RiderCardContent';
import { getPermitType } from '../../../../app/common/util/util';

interface Props {
    values: PermitFormValues,
    goTo: (step: number) => void
}

export default observer(function PermitFormStep6FinalReviewRight({ 
    values,
    goTo
 }: Props) {
    const {permitStore} = useStore();
    const { getRouteName } = permitStore;
    const buttonSize = 'large';

    return (
       <>
            <Segment basic>
                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Route' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={() => goTo(1)}
                        content='Change'
                        size={buttonSize}
                        className='change-btn'
                    />
                    <Header 
                        as='h3'
                        content={`${getRouteName(+values.routeId)} - Permit Effective Thru: ${format(new Date(values.effectiveThru), 'MM/dd/yyyy')}`}
                        block
                        className='clear-both'
                    />
                </Segment>

                <PermitFormStep6FinalReviewRightSchedule1 values={values} goTo={goTo} buttonSize={buttonSize} />

                {values.scheduleTypeInd === "2" &&
                    <PermitFormStep6FinalReviewRightSchedule2 values={values} goTo={goTo} buttonSize={buttonSize} />
                }
                
                <Segment clearing>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Vehicle Information' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={() => goTo(4)}
                        content='Change'
                        size={buttonSize}
                        className='change-btn'
                    />
                    <Segment basic className='clear-both'>
                        <Card.Group itemsPerRow={3} stackable doubling>
                        {values.vehicles.map((v) => (
                            <Card key={`${v.id}`}
                                className={v.vehicleIsPrimary ? 'border-green' : 'no-border'}>
                                {v.vehicleIsPrimary ? (
                                    <Label 
                                        size='large' 
                                        color='green' 
                                        attached='top'
                                    >
                                        <Icon name='star' />
                                        Primary
                                    </Label>
                                ) : (
                                    <Label 
                                        size='large' 
                                        color='orange' 
                                        attached='top'
                                    >
                                        <Icon name='star outline' className='outline-none' />
                                        Alternate
                                    </Label>
                                )}
                                <VehicleCardContent vehicle={v} permit={values} />
                            </Card>
                        ))}
                        </Card.Group>
                    </Segment>
                </Segment>
                <Segment clearing>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Rider Information' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={() => goTo(5)}
                        content='Change'
                        size={buttonSize}
                        className='change-btn'
                    />
                    <Segment basic className='clear-both'>
                        <Card.Group itemsPerRow={3} stackable doubling>
                            {values.riders.map((r, i) => (
                                <Card key={`${i}`}>
                                    <Label 
                                        size='large'
                                        attached='top'
                                        className='!bg-green-800 !text-white'
                                    >
                                    <Icon name='user' />
                                    Rider {i + 1}
                                    </Label>
                                    <RiderCardContent rider={r} />
                                </Card>
                            ))}
                        </Card.Group>
                    </Segment>
                </Segment>
                <Segment clearing>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Payment Information' 
                        color='teal' 
                        floated='left' 
                    />
                    <Container className='clear-both'>
                    There is cost of 20.00 associated with the {getPermitType(values.permitTypeId, true)} Permit.<br />
                    <span style={{fontWeight: 'bold'}}>Please call 206-515-3464, Monday through Friday, between 8:00 a.m. and 4:30 p.m. to facilitate payment for your permit. Thank you.</span>
                    </Container>
                </Segment>
            </Segment>
       </>
    )
})